// =====================================================================
// SERP Rank Tracking — action types
// =====================================================================

// ---------- serpreport (REPORT) ----------
export const SERP_REPORT_LIST = "SERP_REPORT_LIST";
export const SERP_REPORT_LIST_SUCCESS = "SERP_REPORT_LIST_SUCCESS";
export const SERP_REPORT_LIST_FAIL = "SERP_REPORT_LIST_FAIL";

export const SERP_REPORT_DATA = "SERP_REPORT_DATA";
export const SERP_REPORT_DATA_SUCCESS = "SERP_REPORT_DATA_SUCCESS";
export const SERP_REPORT_DATA_FAIL = "SERP_REPORT_DATA_FAIL";

export const SERP_REPORT_CREATE = "SERP_REPORT_CREATE";
export const SERP_REPORT_CREATE_SUCCESS = "SERP_REPORT_CREATE_SUCCESS";
export const SERP_REPORT_CREATE_FAIL = "SERP_REPORT_CREATE_FAIL";
export const SERP_REPORT_CREATE_RESET = "SERP_REPORT_CREATE_RESET";

export const SERP_REPORT_UPDATE = "SERP_REPORT_UPDATE";
export const SERP_REPORT_UPDATE_SUCCESS = "SERP_REPORT_UPDATE_SUCCESS";
export const SERP_REPORT_UPDATE_FAIL = "SERP_REPORT_UPDATE_FAIL";
export const SERP_REPORT_UPDATE_RESET = "SERP_REPORT_UPDATE_RESET";

export const SERP_REPORT_DELETE = "SERP_REPORT_DELETE";
export const SERP_REPORT_DELETE_SUCCESS = "SERP_REPORT_DELETE_SUCCESS";
export const SERP_REPORT_DELETE_FAIL = "SERP_REPORT_DELETE_FAIL";
export const SERP_REPORT_DELETE_RESET = "SERP_REPORT_DELETE_RESET";

export const SERP_REPORT_RUN = "SERP_REPORT_RUN";
export const SERP_REPORT_RUN_SUCCESS = "SERP_REPORT_RUN_SUCCESS";
export const SERP_REPORT_RUN_FAIL = "SERP_REPORT_RUN_FAIL";
export const SERP_REPORT_RUN_RESET = "SERP_REPORT_RUN_RESET";

export const SERP_REPORT_PDF = "SERP_REPORT_PDF";
export const SERP_REPORT_PDF_SUCCESS = "SERP_REPORT_PDF_SUCCESS";
export const SERP_REPORT_PDF_FAIL = "SERP_REPORT_PDF_FAIL";
export const SERP_REPORT_PDF_RESET = "SERP_REPORT_PDF_RESET";

export const SERP_REPORT_SNAPSHOT_PDF = "SERP_REPORT_SNAPSHOT_PDF";
export const SERP_REPORT_SNAPSHOT_PDF_SUCCESS = "SERP_REPORT_SNAPSHOT_PDF_SUCCESS";
export const SERP_REPORT_SNAPSHOT_PDF_FAIL = "SERP_REPORT_SNAPSHOT_PDF_FAIL";
export const SERP_REPORT_SNAPSHOT_PDF_RESET = "SERP_REPORT_SNAPSHOT_PDF_RESET";

export const SERP_REPORT_EMAIL = "SERP_REPORT_EMAIL";
export const SERP_REPORT_EMAIL_SUCCESS = "SERP_REPORT_EMAIL_SUCCESS";
export const SERP_REPORT_EMAIL_FAIL = "SERP_REPORT_EMAIL_FAIL";
export const SERP_REPORT_EMAIL_RESET = "SERP_REPORT_EMAIL_RESET";

// ---------- serpreportsearchitem (ITEM / keyword) ----------
export const SERP_ITEM_LIST = "SERP_ITEM_LIST";
export const SERP_ITEM_LIST_SUCCESS = "SERP_ITEM_LIST_SUCCESS";
export const SERP_ITEM_LIST_FAIL = "SERP_ITEM_LIST_FAIL";

export const SERP_ITEM_DATA = "SERP_ITEM_DATA";
export const SERP_ITEM_DATA_SUCCESS = "SERP_ITEM_DATA_SUCCESS";
export const SERP_ITEM_DATA_FAIL = "SERP_ITEM_DATA_FAIL";

export const SERP_ITEM_CREATE = "SERP_ITEM_CREATE";
export const SERP_ITEM_CREATE_SUCCESS = "SERP_ITEM_CREATE_SUCCESS";
export const SERP_ITEM_CREATE_FAIL = "SERP_ITEM_CREATE_FAIL";
export const SERP_ITEM_CREATE_RESET = "SERP_ITEM_CREATE_RESET";

export const SERP_ITEM_UPDATE = "SERP_ITEM_UPDATE";
export const SERP_ITEM_UPDATE_SUCCESS = "SERP_ITEM_UPDATE_SUCCESS";
export const SERP_ITEM_UPDATE_FAIL = "SERP_ITEM_UPDATE_FAIL";
export const SERP_ITEM_UPDATE_RESET = "SERP_ITEM_UPDATE_RESET";

export const SERP_ITEM_DELETE = "SERP_ITEM_DELETE";
export const SERP_ITEM_DELETE_SUCCESS = "SERP_ITEM_DELETE_SUCCESS";
export const SERP_ITEM_DELETE_FAIL = "SERP_ITEM_DELETE_FAIL";
export const SERP_ITEM_DELETE_RESET = "SERP_ITEM_DELETE_RESET";

// ---------- serpreportsnapshot (SNAPSHOT / run) ----------
export const SERP_SNAPSHOT_LIST = "SERP_SNAPSHOT_LIST";
export const SERP_SNAPSHOT_LIST_SUCCESS = "SERP_SNAPSHOT_LIST_SUCCESS";
export const SERP_SNAPSHOT_LIST_FAIL = "SERP_SNAPSHOT_LIST_FAIL";

export const SERP_SNAPSHOT_DATA = "SERP_SNAPSHOT_DATA";
export const SERP_SNAPSHOT_DATA_SUCCESS = "SERP_SNAPSHOT_DATA_SUCCESS";
export const SERP_SNAPSHOT_DATA_FAIL = "SERP_SNAPSHOT_DATA_FAIL";

export const SERP_SNAPSHOT_DELETE = "SERP_SNAPSHOT_DELETE";
export const SERP_SNAPSHOT_DELETE_SUCCESS = "SERP_SNAPSHOT_DELETE_SUCCESS";
export const SERP_SNAPSHOT_DELETE_FAIL = "SERP_SNAPSHOT_DELETE_FAIL";
export const SERP_SNAPSHOT_DELETE_RESET = "SERP_SNAPSHOT_DELETE_RESET";

// ---------- serpreportsearchitemresult (RESULT / position) ----------
export const SERP_RESULT_BY_SNAPSHOT = "SERP_RESULT_BY_SNAPSHOT";
export const SERP_RESULT_BY_SNAPSHOT_SUCCESS = "SERP_RESULT_BY_SNAPSHOT_SUCCESS";
export const SERP_RESULT_BY_SNAPSHOT_FAIL = "SERP_RESULT_BY_SNAPSHOT_FAIL";

export const SERP_RESULT_BY_ITEM = "SERP_RESULT_BY_ITEM";
export const SERP_RESULT_BY_ITEM_SUCCESS = "SERP_RESULT_BY_ITEM_SUCCESS";
export const SERP_RESULT_BY_ITEM_FAIL = "SERP_RESULT_BY_ITEM_FAIL";

export const SERP_RESULT_DATA = "SERP_RESULT_DATA";
export const SERP_RESULT_DATA_SUCCESS = "SERP_RESULT_DATA_SUCCESS";
export const SERP_RESULT_DATA_FAIL = "SERP_RESULT_DATA_FAIL";

// Full organic SERP behind a single result (competitors)
export const SERP_RESULT_ORGANIC = "SERP_RESULT_ORGANIC";
export const SERP_RESULT_ORGANIC_SUCCESS = "SERP_RESULT_ORGANIC_SUCCESS";
export const SERP_RESULT_ORGANIC_FAIL = "SERP_RESULT_ORGANIC_FAIL";
export const SERP_RESULT_ORGANIC_RESET = "SERP_RESULT_ORGANIC_RESET";
